/**
 * MobileExpandableDescription
 * --------------------------
 * Used for hero body copy across the service pages.
 *
 * It used to clamp to three lines on mobile behind a "... more" toggle. That
 * hid the paragraph that sells the page on exactly the screens where it
 * matters most, so the copy now renders in full at every width.
 *
 * Kept as a component rather than inlined: the seven pages that use it pass
 * their own `className`, and it also means the clamp can come back in one
 * place if it is ever wanted again.
 */
export default function MobileExpandableDescription({ children, className = '' }) {
  return <div className={className}>{children}</div>
}
